// extracted by mini-css-extract-plugin
module.exports = {"statusLabel":"status-label_statusLabel__zVMXN"};